import { Box } from "@chakra-ui/react";
import React from "react";

export default function Videos() {
    return(
    <Box minH="lg">
        <h2>Videos</h2>
    </Box>
    );
}